module.exports = __webpack_public_path__ + "static/img/ScanCode.fb67a955.png";